import { UnitSystem } from 'src/app/shared/enums/unit-system.enum';
import { UnitConversionService, UNITS } from 'src/app/shared/services/unit-conversion.service';

// Centralized initial form defaults for Advanced Pipe Rating module
export function getAdvancedPipeFormDefaults(unitSystem: UnitSystem = UnitSystem.USC) {
  
  const baseUSC = {
    // PIPE section - no defaults, stay null
    outerDiameter: null, // in
    wallThickness: null, // in
    minWallThickness: null, // percentage
    grade: null, // string
    
    // MATERIAL section
    maxFlawSize: 0, // in
    materialToughness: 2, // dimensionless
    ovality: null, // dimensionless percentage
    eccentricity: null, // dimensionless percentage
    poisson: 0.3, // dimensionless ratio
    residualStress: null, // dimensionless ratio
    smys: null, // ksi 
    uts: null, // ksi
    youngModulus: 30000, // ksi
    hotRotaryStraightening: 'None', // string
    
    // LOADS section
    realAxialLoad: 0, // kips
    internalPressure: 0, // ksi
    externalPressure: 0 // ksi
  };

  const baseSI = {
    // PIPE section - no defaults, stay null
    outerDiameter: null, // mm
    wallThickness: null, // mm
    minWallThickness: null, // percentage
    grade: null, // string
    
    // MATERIAL section
    maxFlawSize: 0, // mm
    materialToughness: 2, // dimensionless 
    ovality: null, // dimensionless percentage
    eccentricity: null, // dimensionless percentage
    poisson: 0.3, // dimensionless ratio
    residualStress: null, // dimensionless ratio
    smys: null, // MPa
    uts: null, // MPa
    youngModulus: 206843, // MPa (30000 ksi * 6.89476)
    hotRotaryStraightening: 'None', // string
    
    // LOADS section
    realAxialLoad: 0, // kN
    internalPressure: 0, // MPa
    externalPressure: 0 // MPa
  };

  return unitSystem === UnitSystem.USC ? baseUSC : baseSI;
}